<template>
  <div>
    <Button
      text
      icon="pi pi-trash"
      size="small"
      severity="danger"
      @click="dialog.visible = true"
    />

    <Dialog
      v-model:visible="dialog.visible"
      header="Remove Relationship"
      modal
      :style="{ width: '25rem' }"
    >
      <div class="space-y-4">
        <div class="flex items-center gap-2">
          <i class="pi pi-info-circle text-3xl" />
          <p>Do you want to remove this relationship?</p>
        </div>

        <div class="flex justify-end gap-2">
          <Button
            type="button"
            label="Cancel"
            icon="pi pi-times"
            outlined
            :disabled="dialog.loading"
            @click="dialog.visible = false"
          />
          <Button
            type="button"
            severity="danger"
            label="Remove"
            icon="pi pi-trash"
            :loading="dialog.loading"
            @click="removeRelationship"
          />
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script lang="ts" setup>
const toast = useToast()
const { deleteContactLink } = useContacts()
const emit = defineEmits(['refresh'])

const dialog = ref({
  visible: false,
  loading: false,
})

const props = defineProps<{
  relationshipId: string
}>()

const removeRelationship = async () => {
  dialog.value.loading = true

  try {
    const { error } = await deleteContactLink(props.relationshipId)

    if (error) {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: error?.data.message || 'Error removing contact relationship',
        life: 3000,
      })
      dialog.value.loading = false
      return
    }

    emit('refresh')
  }
  catch (error) {
    console.error('Error removing contact relationship:', error)
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to remove contact relationship',
      life: 3000,
    })
    dialog.value.loading = false
  }
}
</script>
